import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-idle-warning-dialog',
    template: `
    <h2 mat-dialog-title>Are you still there?</h2>
    <mat-dialog-content>
      <p>Your session will expire soon due to inactivity. <strong>{{ countdown }}</strong> seconds remaining.</p>
    </mat-dialog-content>
  `,
    standalone: false
})

export class IdleWarningDialogComponent {
    countdown: number;
    private mouseMoveListener: any;
    constructor(@Inject(MatDialogRef) private dialogRef: MatDialogRef<IdleWarningDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject(ChangeDetectorRef) public cdRef: ChangeDetectorRef
    ) {
        this.countdown = data.countdown;

        // Watch for mouse movement to reset session
        this.mouseMoveListener = () => {
            this.dialogRef.close(true); // "true" means stay logged in
        };

        window.addEventListener('mousemove', this.mouseMoveListener);
    }

    updateCountdown(value: number) {
        this.countdown = value;
        this.cdRef.detectChanges();
    }

    ngOnDestroy(): void {
        window.removeEventListener('mousemove', this.mouseMoveListener);
    }

}
